// extracted by mini-css-extract-plugin
export default {"gradientButton":"gradientbutton_gradientButton__pbGyx"};